import { EmptyView, emptyViewVariants } from '@components'

import { Flex, Spacing } from '@billy/design-system'
import { ReactElement } from 'react'

import { IMPORTED_INVOICE_MAX_SIZE_MB } from '@features/importedInvoices/constants/importedInvoicesUpload'
import { ImportedInvoicesUploadButton } from '@features/importedInvoices/elements/ImportedInvoicesUploadButton'

export const ImportedInvoicesListEmpty = (): ReactElement => {
  const { description, illustration, title } = emptyViewVariants.importedInvoices

  return (
    <Flex flexDirection="column" alignItems="center" justifyContent="center" gap={Spacing.S32}>
      {/* EmptyView stretches to `height: 100%`; keep it content-sized so the CTA stays visible beneath it. */}
      <Flex.Item flexGrow={0} flexShrink={0}>
        <EmptyView
          descriptionOptions={{ maxSizeMb: IMPORTED_INVOICE_MAX_SIZE_MB }}
          illustration={illustration}
          tDescription={description}
          tTitle={title}
        />
      </Flex.Item>
      <ImportedInvoicesUploadButton size="lg" />
    </Flex>
  )
}
